import { Modal, Form, Input, Button, Select, Row, Col, Switch, Upload, Tooltip } from "antd";
import Draggable from "react-draggable";
import { FileExcelOutlined, UploadOutlined } from "@ant-design/icons";

import { formItemLayout, inputLayout, inputLayout2 } from "../../../../constants/ApplicationConstants/FormConstants";
import CircularProgressBar from "../../../common/CircularProgressBar";
import Loading from "../../../common/Loading";
import FormInputRules from "../../../../util/FormInputRules";
import { General } from "../../../../util/General";
import { createHandleEditKeyPress, createHandleKeyPress } from "../../../../util/handleKeyPress";
import { useCustomerClientMaster } from "./index.hook";
import { useReactDraggable } from "../../../../hooks/useReactDraggable";
import styles from "../../index.module.less";

import type FixMeLater from "../../../../shared/types/fixMeLater.type";

type CustomerClientMasterProps = {
  saving: boolean;
  addRecord: boolean;
  handleAddRecord: (value: boolean) => void;
  rowData: FixMeLater;
  handleClearRowIdAndActionType: () => void;
  handleSubmit: (data: FixMeLater) => void;
};

const CustomerClientMaster = (props: CustomerClientMasterProps) => {
  const config = useCustomerClientMaster(props);

  const { bounds, onStart } = useReactDraggable();

  return (
    <Modal
      afterClose={() => config.form.resetFields()}
      destroyOnClose={true}
      maskClosable={false}
      centered
      title={<div className="modal-container">{`${props.addRecord ? "Add" : "Edit"} Customer Client Master`}</div>}
      open={true}
      onCancel={props.addRecord ? props.handleAddRecord.bind(this, false) : props.handleClearRowIdAndActionType}
      width={props.addRecord && config.isBulkEntry ? "50%" : "80%"}
      okButtonProps={{
        style: {
          display: "none"
        }
      }}
      cancelButtonProps={{ style: { display: "none" } }}
      modalRender={(modal) => (
        <Draggable bounds={bounds} handle=".ant-modal-header" onStart={(event, uiData) => onStart(event as any, uiData)}>
          {modal}
        </Draggable>
      )}
    >
      {((props.addRecord && config.isOnAddLoading) || (!props.addRecord && !config.formFieldsLoadedToForm)) && (
        <div className={`${styles["textCenter"]}`}>
          <Loading />
        </div>
      )}

      {((props.addRecord && !config.isOnAddLoading) || (!props.addRecord && config.formFieldsLoadedToForm)) && (
        <Form
          ref={config.formRef}
          onValuesChange={(changedValues) => {
            const fieldName = Object.keys(changedValues)[0];
            config.form.validateFields([fieldName]);
          }}
          className={`${styles["formDiv"]} ${styles["formDivExtended"]}`}
          {...formItemLayout}
          form={config.form}
          validateTrigger="onBlur"
          colon={false}
          name="register"
          onFinish={config.handleSubmit}
        >
          {/* bulk entry only */}
          {props.addRecord && config.isBulkEntry && (
            <>
              <Form.Item {...inputLayout} name="isBulkEntry" label="Entry Type">
                <Switch checked={config.isBulkEntry} onChange={config.handleBulkEntry} checkedChildren="Bulk Entries" unCheckedChildren="Single Entry" />
              </Form.Item>

              {/* <Form.Item {...inputLayout} name="customer_id" label="Customer" rules={[FormInputRules.requiredFieldSelectRule("customer name")]}>
                <Select className={`${styles["from-Item-selectDiv"]}`} listHeight={200} onChange={config.handleChangeCustomer} showSearch allowClear getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} placeholder="Select customer">
                  {config.customerMasterList?.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.customer_name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item> */}

              {/* <Form.Item {...inputLayout} name="customer_location_id" label="Location" rules={[FormInputRules.requiredFieldSelectRule("location name")]}>
                <Select className={`${styles["from-Item-selectDiv"]}`} showSearch allowClear listHeight={200} getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} placeholder="Select location">
                  {config.locationList?.map((item: { id: number; location_name: string }) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.location_name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item> */}

              <Form.Item
                {...inputLayout}
                label="Upload Excel File"
                name="bulk_entry"
                rules={[
                  {
                    required: true,
                    message: `Please upload excel file.`
                  }
                ]}
              >
                <Upload beforeUpload={config.handleUpload} showUploadList={false} accept=".xls,.xlsx">
                  <Button icon={<UploadOutlined />}>Click to Upload</Button>
                </Upload>

                <Tooltip title="Download Sample Excel File">
                  <Button type="link" className={styles["excel-button-container"]} icon={<FileExcelOutlined className={styles["excel-icon"]} />} onClick={config.downloadSampleExcel} />
                </Tooltip>
              </Form.Item>
            </>
          )}

          {/* single entry form */}
          {(!props.addRecord || !config.isBulkEntry) && (
            <Row gutter={24}>
              <Col span={12} xs={24} sm={24} md={24} lg={12}>
                {props.addRecord && (
                  <Form.Item {...inputLayout} name="isBulkEntry" label="Entry Type">
                    <Switch checked={config.isBulkEntry} onChange={config.handleBulkEntry} checkedChildren="Bulk Entries" unCheckedChildren="Single Entry" />
                  </Form.Item>
                )}

                <Form.Item {...inputLayout2} name="client_name" label="Client Name" normalize={General.inputWhiteSpaceRemove} rules={[FormInputRules.requiredFieldInputRule("client name"), FormInputRules.ValidateNameField()]}>
                  <Input name="client_name" />
                </Form.Item>

                {/* <Form.Item {...inputLayout2} name="customer_id" label="Customer" rules={[FormInputRules.requiredFieldSelectRule("customer name")]}>
                  <Select className={`${styles["from-Item-selectDiv"]}`} listHeight={200} onChange={config.handleChangeCustomer} showSearch allowClear getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} placeholder="Select customer">
                    {config.customerMasterList?.map((item) => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.customer_name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item {...inputLayout2} name="customer_location_id" label="Location" rules={[FormInputRules.requiredFieldSelectRule("location name")]}>
                  <Select className={`${styles["from-Item-selectDiv"]}`} showSearch allowClear listHeight={200} getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} placeholder="Select location">
                    {config.locationList?.map((item: { id: number; location_name: string }) => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.location_name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item> */}

                <Form.Item {...inputLayout2} name="allocated_parking" label="Allocated Parking" normalize={General.inputWhiteSpaceRemove} rules={[FormInputRules.requiredFieldInputRule("allocated parking"), FormInputRules.NumberValidationRule()]}>
                  <Input name="allocated_parking" type="number" min={1} />
                </Form.Item>
              </Col>
              <Col span={12} xs={24} sm={24} md={24} lg={12}>
                <Form.Item {...inputLayout2} name="client_contact" label="Contact Name" normalize={General.inputWhiteSpaceRemove} rules={[FormInputRules.requiredFieldInputRule("client contact"), FormInputRules.ValidateFirstAndLastName()]}>
                  <Input name="client_contact" />
                </Form.Item>

                {props.addRecord ? (
                  <Form.Item {...inputLayout2} name="mobile_number" label="Contact Number" normalize={General.inputWhiteSpaceRemove} rules={[FormInputRules.requiredFieldInputRule("contact number"), FormInputRules.ContactNumberValidation2Rule()]}>
                    <Input prefix="+91" name="mobile_number" onKeyPress={createHandleKeyPress()} />
                  </Form.Item>
                ) : (
                  <Form.Item {...inputLayout2} name="mobile_number" label="Contact Number" normalize={General.inputWhiteSpaceRemove} rules={[FormInputRules.requiredFieldInputRule("contact number"), FormInputRules.ContactNumberValidationRule()]}>
                    <Input name="mobile_number" onKeyPress={createHandleEditKeyPress()} />
                  </Form.Item>
                )}

                <Form.Item {...inputLayout2} name="email_address" label="Email Address" normalize={General.inputWhiteSpaceRemove} rules={[FormInputRules.EmailValidationRule()]}>
                  <Input name="email_address" />
                </Form.Item>
              </Col>
            </Row>
          )}

          <Form.Item className={`${styles["form-itemFloatR20"]}`}>
            <Button className={`gx-mb-0 button-gradiant ${styles["button-m01"]}`} htmlType="submit">
              {props.saving ? <CircularProgressBar /> : props.addRecord ? "Submit" : "Update"}
            </Button>
          </Form.Item>

          <Form.Item className={`${styles["form-itemFloatR20"]}`}>
            <Button disabled={props.saving} className={`gx-mb-0 button-gradiant ${styles["button-m01"]}`} onClick={props.addRecord ? props.handleAddRecord.bind(this, false) : props.handleClearRowIdAndActionType}>
              Close
            </Button>
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default CustomerClientMaster;
